// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"350":"062428bf","449":"ecc071d4","784":"cb114cb8","986":"bb6e1a79"}[chunkId] + ".chunk.css";
};